import React, {forwardRef} from "react";
import PropTypes from "prop-types";
import {ADivider} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import css from "./DrawerContent.module.scss";

/**
 * Used to wrap content inside of drawers with an optional
 * content divider placed at the bottom.
 */
const DrawerContent = forwardRef(
  ({children, hideDivider = false, className, ...rest}, ref) => {
    return (
      <>
        <div
          ref={ref}
          className={classNames(css.drawerContent, className)}
          {...rest}>
          {children}
        </div>
        {!hideDivider && <ADivider />}
      </>
    );
  }
);

DrawerContent.propTypes = {
  /**
   * Optional className to apply to the component.
   */
  className: PropTypes.string,

  /**
   * Determines if the drawer section should render with a divider
   * at the bottom of the component.
   */
  hideDivider: PropTypes.bool
};

export default DrawerContent;
